import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { BasicDesignView } from '../components/features/basic-design/BasicDesignView.js';
import { canonicalBdKey } from './-bd-key.js';
import { parseBdDetailSearch } from './-bd-search.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計 1 件のページ。チケット（親チケットか子チケット）ごとに基本設計の全節を読み書きする。URL の section で最初に開く節を選べる。小文字のチケット番号は大文字の URL へ送り直す
 * @graph-connects BasicDesignView [calls] 基本設計ビュー描画
 * @graph-connects canonicalBdKey [calls] チケット番号の正規化
 * @graph-connects parseBdDetailSearch [calls] 最初に開く節の検証
 */
export const Route = createFileRoute('/projects/bd/$bdKey')({
  validateSearch: parseBdDetailSearch,
  beforeLoad: ({ params, search }) => {
    const canonical = canonicalBdKey(params.bdKey);
    if (canonical !== null) {
      throw redirect({
        to: '/projects/bd/$bdKey',
        params: { bdKey: canonical },
        search,
        replace: true,
      }) as unknown as Error;
    }
  },
  component: BasicDesignPage,
});

/**
 * 送り直しより先に描かれても、小文字のまま API を呼ばないよう大文字にして渡す。
 * @graph-connects BasicDesignView [calls] 基本設計ビュー描画
 * @graph-connects canonicalBdKey [calls] チケット番号の正規化
 */
function BasicDesignPage() {
  const { bdKey } = Route.useParams();
  const { section } = Route.useSearch();
  return (
    <ProtectedRoute pageKey="basicDesign">
      <BasicDesignView bdKey={canonicalBdKey(bdKey) ?? bdKey} initialSection={section} />
    </ProtectedRoute>
  );
}
